export const ADS_TYPE_OPTIONS = [
  { name: "RIGHT", label: "Banner Kanan", value: "RIGHT" },
  { name: "LEFT", label: "Banner Kiri", value: "LEFT" },
];
